import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OtherArticleIdentifierDto, PickListDataDto } from '@scip/api';
import { v4 } from 'uuid';
import { NotificationService, MasterDataService, EnvironmentConfigurationService } from '../../../services';
import { translationKeys } from '../../../core';
import { typeField } from '@avano/avano-components/utils';
import { TableColumnConfiguration } from '@avano/avano-components/avano-table';

@Component({
  selector: 'scip-other-article-identifier-dialog',
  templateUrl: './other-article-identifier-dialog.component.html',
  styleUrls: ['./other-article-identifier-dialog.component.scss']
})
export class OtherArticleIdentifierDialogComponent implements OnInit {
  @Input()
  set otherArticleIdentifiers(val: OtherArticleIdentifierDto[]) {
    if (val && val.length !== 0) {
      this.rowData = this.mapToRowData([...val]);
    }
  }

  @Output() readonly closeEvent: EventEmitter<void> = new EventEmitter<void>();
  @Output() readonly saveEvent: EventEmitter<OtherArticleIdentifierDto[]> = new EventEmitter<OtherArticleIdentifierDto[]>();

  columnKeys = {
    pickListData: typeField<OtherArticleIdentifierDto>('pickListData'),
    value: typeField<OtherArticleIdentifierDto>('value')
  };

  columnConfig: TableColumnConfiguration[] = [
    {
      header: translationKeys.otherArticleIdentifierDialogComponent.ts.column.identifierType,
      field: this.columnKeys.pickListData
    },
    {
      header: translationKeys.otherArticleIdentifierDialogComponent.ts.column.identifierValue,
      field: this.columnKeys.value
    }
  ];
  deleteDisabled = true;
  loading = true;
  primaryArticleIdentifierListSuggestions: PickListDataDto[] = [];
  selectedIdentifier: { id: string } & OtherArticleIdentifierDto;
  showDialog = true;
  totalCount = 0;
  rowData: Array<{ id: string } & OtherArticleIdentifierDto> = [];
  translationKeys: typeof translationKeys = translationKeys;

  private primaryArticleIdentifierList: PickListDataDto[] = [];

  private defaultOtherArticleIdentifier: PickListDataDto;

  constructor(
    private masterDataService: MasterDataService,
    private notificationService: NotificationService,
    private environmentConfigurationService: EnvironmentConfigurationService
  ) {}

  ngOnInit(): void {
    this.initializeData();
    this.initializeTable();
  }

  addIdentifier(): void {
    this.rowData.push({ id: v4(), pickListData: this.defaultOtherArticleIdentifier, value: '' });
    this.rowData = [...this.rowData];
  }

  deleteIdentifier(): void {
    if (this.selectedIdentifier) {
      this.rowData.splice(
        this.rowData.findIndex((data) => data.id === this.selectedIdentifier.id),
        1
      );
      this.rowData = [...this.rowData];
      this.selectedIdentifier = undefined;
      this.updateDeleteButtonStatus();
    }
  }

  emitOtherArticleIdentifiers(): void {
    if (this.checkValidation()) {
      const identifiers: OtherArticleIdentifierDto[] = this.rowData.map(({ pickListData, value }) => ({ pickListData, value }));
      this.saveEvent.emit(identifiers);
    } else {
      this.notificationService.showError(translationKeys.otherArticleIdentifierDialogComponent.html.notification.validationError);
    }
  }

  filterPrimaryArticleIdentifierList(event: { query: string }): void {
    this.primaryArticleIdentifierListSuggestions = this.primaryArticleIdentifierList.filter((singleID: PickListDataDto) => {
      return singleID.text.toLowerCase().startsWith(event.query.toLowerCase());
    });
  }

  updateDeleteButtonStatus(): void {
    this.deleteDisabled = !this.selectedIdentifier;
  }

  private checkValidation(): boolean {
    return !this.rowData.find((data) => !(data.pickListData?.text && data.value?.trim().length));
  }

  private initializeTable(): void {
    if (this.rowData.length > 1) {
      this.totalCount = this.rowData.length;
    }
    this.loading = false;
  }

  private initializeData() {
    const { defaultOAI } = this.environmentConfigurationService.environment;

    this.masterDataService.getPrimaryArticleIdentifierTypes().subscribe((data: PickListDataDto[]) => {
      this.primaryArticleIdentifierList = data;
      this.defaultOtherArticleIdentifier = data.find((item) => item.identifier === defaultOAI);
    });
  }

  // We need to add additional custom unique key to identify a row for selection as two identifiers can have exactly the same value
  private mapToRowData(data: OtherArticleIdentifierDto[]): Array<{ id: string } & OtherArticleIdentifierDto> {
    return data.map(({ pickListData, value }) => ({
      id: v4(),
      pickListData,
      value
    }));
  }
}
